import { FOCUS_RING } from "@sportsmet/ui";
import type { ReactNode } from "react";

export function RequestsRow({
  onSelect,
  testId,
}: {
  onSelect: () => void;
  testId?: string;
}): ReactNode {
  return (
    <button
      type="button"
      onClick={onSelect}
      data-testid={testId}
      className={`flex w-full min-h-touch-target items-center gap-3 py-2 text-left ${FOCUS_RING}`}
    >
      <span
        className="h-2.5 w-2.5 shrink-0 rounded-full bg-primary-solid"
        aria-hidden="true"
      />
      <span className="text-body-strong text-ink">Requests</span>
      <span className="sr-only">Someone is waiting to message you</span>
    </button>
  );
}
